import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";
import { Loader } from "semantic-ui-react";

import { QUESTIONNAIRE_KEY } from "@teamprevent/common/ppq/components/PpqManagerSection";
import { selectManagerSectionQuestionnaireAsQuestionnaireConfig } from "@teamprevent/common/ppq/selector";
import { WorkGroup } from "@teamprevent/common/workGroup/model";
import { loadOrgStructure as loadOrgStructureAction } from "@teamprevent/common/questionnaires/components/referralForm/actions";

import { loadManagerQuestionnaire as loadManagerQuestionnaireAction } from "../actions";
import { ApplicationState } from "../../applicationState";
import { workGroupApi } from "../../workGroup/workGroupApi";

import { PpqForm } from "./PpqForm";

export const ReadonlyPpqForm: React.FunctionComponent = () => {

    const [loading, setLoading] = React.useState<boolean>(true);
    const [customerWorkGroups, setCustomerWorkGroups] = React.useState<WorkGroup[]>([]);

    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const questionnaireConfig = useSelector((state: ApplicationState) => selectManagerSectionQuestionnaireAsQuestionnaireConfig(state));
    const allowedCovid19Features = useSelector((state: ApplicationState) => state.allowedCovid19Features);

    const dispatch = useDispatch();

    React.useEffect(() => {
        (async () => {
            const workGroups = await workGroupApi.getAll();
            setCustomerWorkGroups(workGroups);
        })();

        setLoading(false);
    }, []);

    React.useEffect(() => {
        if (ohCaseId) {
            dispatch(loadManagerQuestionnaireAction(ohCaseId, QUESTIONNAIRE_KEY));
        }
    }, [ohCaseId]);

    const loadOrgStructure = (parentOrgStructureLevelId: string) => {
        dispatch(loadOrgStructureAction(parentOrgStructureLevelId));
    };

    if (questionnaireConfig && !loading) {
        return (
            <PpqForm
                readonly={true}
                questionnaireConfig={questionnaireConfig}
                allowedCovid19Features={allowedCovid19Features}
                loadOrgStructure={loadOrgStructure}
                customerWorkGroups={customerWorkGroups}
            />
        );
    }

    return <Loader active />;
};
